export const comboboxMultiSelectPillClassName =
  'border-neutral-color-soft flex min-w-0 max-w-full items-center rounded-[20px] border-[1.5px] px-2 py-1 text-sm';

interface ComboboxMultiSelectPillLabelsProps {
  labels: string[];
}

export const ComboboxMultiSelectPillLabels = ({
  labels,
}: ComboboxMultiSelectPillLabelsProps) => (
  <div className="flex min-w-0 flex-1 flex-wrap gap-1 overflow-hidden">
    {labels.map((label, index) => (
      <span
        key={`${label}-${index}`}
        className={comboboxMultiSelectPillClassName}
      >
        <span className="min-w-0 truncate">{label}</span>
      </span>
    ))}
  </div>
);
